import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import ForgotPage from "../../components/Account/Forgot";
import ToastError from "../../components/Notification/ToastError";
import { headers } from "../../libs";
import { ValForgot } from "../../validation/UserValidation";

function Forgot() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState([]);

  const [open, setOpen] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  const onChange = (e) => {
    setEmail(e.target.value);
    setError([]);
  };

  const onSubmit = async () => {
    setLoading(true);

    const error = await ValForgot(email);
    if (error.length > 0) {
      setError(error);
      setLoading(false);
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/forget`,
          { email: email },
          { headers: await headers({ email: email }) }
        );

        if (Number(response.data.code) === 200) {
          // toastSuccess(response.data.message);
          setTimeout(() => {
            history.push("/");
            setLoading(false);
          }, 4500);
        } else {
          setLoading(false);
          setOpen(true);
          setResponse(response.data.message);
        }
      } catch (e) {
        setOpen(true);
        setResponse("");
        setLoading(false);
      }
    }
  };

  return (
    <>
      <ToastError props={{ open, response, onError }} />
      <ForgotPage props={{ email, loading, onChange, onSubmit, isError }} />
    </>
  );
}

export default Forgot;
